export interface Content {
  id: number
  name: string
  type: ContentType
  createdAt: string
  children: Content[]
}

export interface ContentTree {
  userId: string
  accountId: string
  createdAt: string
  content: Content[]
}

export enum ContentType {
  FOLDER = 1,
  FILE = 2
}
